import { Icon, Upload, Spin } from 'antd';
import { RcCustomRequestOptions } from 'antd/lib/upload/interface';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { IVideo } from '../../models/video.model';

import './VideoUpload.scss';

interface IPropsUploadVideo {
    disabled: boolean,
    currentEdit: IVideo,
    setCurrentEdit: (video:IVideo) => void,
};

const getVideoDuration = (file: any) =>   
    new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            const blob = new Blob([file], {type: file.type});
            const url = (URL || webkitURL).createObjectURL(blob);
            const video = document.createElement('video');   
            video.preload = 'metadata';
            video.onloadedmetadata = () => {
                resolve(Math.round(video.duration));
                (URL || webkitURL).revokeObjectURL(url);                
            };
            video.src = url; 
        };

        reader.readAsArrayBuffer(file);
        reader.onerror = error => reject(error);
    });

const VideoUpload = ({
    disabled,
    setCurrentEdit,
    currentEdit,
}: IPropsUploadVideo) => {

    const [hasVideo, setHasVideo] = useState();
    const [loading, setLoading] = useState(false);
    const {name} = useSelector(({videos}: any) => ({name: videos.videoModal.name}));    

    async function handleSetVideo(video: any) {
        const duration = await getVideoDuration(video);
        const keyDuration: string = 'duration'
        updatePayload(keyDuration, duration);
        return duration;
    }

    const handleChange = async (info: any) => {
        setHasVideo(info.file.name);
        const keyUpload: string = 'duration'
        updatePayload(keyUpload, undefined);
        setLoading(true);
        const duration = await handleSetVideo(info.file.originFileObj);
        setLoading(false);
        return duration;
    };

    const handleRequest = async ({file, onSuccess}: RcCustomRequestOptions) => {
        const keyUpload: string = 'uploadedVideo'
        updatePayload(keyUpload, file);
        onSuccess({name: file.name, status: 'done'}, file)
    };
    
    function updatePayload(key: string, value: any) {

        let item = {...currentEdit};
        item = {...item, [key]: value};
        setCurrentEdit(item as IVideo);
    };

    return (
        <>
            <div>
                <Upload
                    name='video-upload'
                    showUploadList={false}
                    accept={'video/mp4'}
                    onChange={handleChange}
                    customRequest={handleRequest}
                    disabled={disabled}
                    style={{height: '74px'}}
                >
                    {
                        (hasVideo || (disabled && name)) ? 
                            <div className='video_upload'> {name || hasVideo} {loading && <Spin/> } </div>
                            :
                            <div className={'upload_btn'}>
                                <Icon type='cloud-upload' style={{ fontSize: 24, marginRight: '8px'}} />
                                <div style={{fontWeight: 'bold',}}>
                                    Escolha um Video
                                </div>
                            </div>
                    }
                </Upload>
            </div>        
        </>
    )
};

export default VideoUpload;